var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Finance = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ width: "37", height: "45" }, props),
        React.createElement("g", null,
            React.createElement("path", { fill: "#00C1B1", d: "M25.127 19.872c0 3.372-3.124 6.105-6.977 6.105-3.854 0-6.977-2.733-6.977-6.105 0-3.372 3.123-6.105 6.977-6.105 3.853 0 6.977 2.733 6.977 6.105", opacity: ".4" }),
            React.createElement("path", { fill: color, d: "M5.048 7.88v16.953c0 1.92.647 3.744 1.824 5.14 2.472 2.928 6.165 5.84 11.279 8.893 5.113-3.053 8.805-5.965 11.279-8.894 1.175-1.395 1.823-3.22 1.823-5.139V7.88L25.169 6.2a26.364 26.364 0 0 0-14.037 0L5.048 7.88zM18.15 40.893l-.444-.26c-5.517-3.252-9.497-6.37-12.169-9.535-1.442-1.71-2.236-3.934-2.236-6.265V6.553l7.366-2.034a28.134 28.134 0 0 1 14.965 0l7.365 2.034v18.28c0 2.331-.794 4.555-2.235 6.264-2.674 3.165-6.654 6.284-12.17 9.535l-.442.261zM1.745 5.135v18.622c0 3.536 1.268 6.812 3.573 9.225 3.055 3.197 7.256 6.37 12.832 9.692 5.576-3.322 9.777-6.495 12.832-9.692 2.305-2.413 3.574-5.689 3.574-9.225V5.135L24.968 2.64a26.42 26.42 0 0 0-13.632 0L1.745 5.134zM18.15 44.7l-.443-.26c-5.938-3.5-10.403-6.854-13.649-10.253C1.441 31.448 0 27.744 0 23.757l.001-19.97L10.891.95a28.156 28.156 0 0 1 14.523.002L36.3 3.786l.001 19.971c0 3.987-1.44 7.691-4.058 10.43-3.247 3.398-7.712 6.752-13.649 10.251l-.443.261zm0-30.831a5.696 5.696 0 0 0-5.69 5.69 5.696 5.696 0 0 0 5.69 5.69 5.696 5.696 0 0 0 5.69-5.69 5.696 5.696 0 0 0-5.69-5.69zm0 13.125c-4.099 0-7.435-3.335-7.435-7.435 0-4.099 3.336-7.435 7.435-7.435s7.435 3.336 7.435 7.435c0 4.1-3.336 7.435-7.435 7.435zm-.838-4.416L14.8 20.064l1.234-1.233 1.277 1.277 2.954-2.953 1.233 1.234-4.187 4.186z" }))));
};
Finance.defaultProps = {
    color: '#111',
};
export default Finance;
//# sourceMappingURL=Finance.js.map